<template>
<div class=" bg-gray-200 text-gray-800 border-r ">
    <h2 class="p-4  font-medium uppercase text-gray-500 tracking-wide">
      Categories
    </h2>

    <ais-hierarchical-menu
      :attributes="[
        'categories.level1',
        'categories.level2',
        'categories.level3',
      ]"
      :limit="999"
      class="font text-sm mb-4"
    />
</div>
</template>

<script>

export default {  
}
</script>

<style>
  .ais-HierarchicalMenu-item {
    
  }
  .ais-HierarchicalMenu-item--selected > .ais-HierarchicalMenu-link {
    @apply font-bold
  }
  .ais-HierarchicalMenu-list--lvl0 > .ais-HierarchicalMenu-item {
    @apply px-4 py-2
  }
  .ais-HierarchicalMenu-list--lvl1  .ais-HierarchicalMenu-item {
    @apply ml-3 my-2
  }

  .ais-HierarchicalMenu-count {
    @apply px-2 py-1 bg-gray-300 rounded text-xs text-gray-700
  }
  .ais-HierarchicalMenu-list--lvl0 > .ais-HierarchicalMenu-item--selected {
    @apply bg-gray-300 text-gray-800 border-t border-b border-gray-300
    
  }
  .ais-HierarchicalMenu-list--lvl0 > .ais-HierarchicalMenu-item--selected .ais-HierarchicalMenu-count {
      @apply bg-gray-200
  }
</style>